import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Toolbar,
  Typography,
  IconButton,
  Button,
  Box,
  Drawer,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";

import styles from "./Navbar.module.css";
import format from "../format.module.css";

/*  UPDATED SECTIONS */
const sections = [
  { label: "home", type: "route", path: "/" },
  { label: "AI Agent", type: "route", path: "/ai-agent" },
  { label: "services", type: "route", path: "/servicedescri" },
  { label: "voiceplots", type: "route", path: "/voiceplots" },
  { label: "Products", type: "route", path: "/products" },
  // { label: "contact", type: "scroll" },
];

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  /* ✅ HANDLES BOTH SCROLL + ROUTE */
  const handleNavClick = (item) => {
    if (item.type === "route") {
      navigate(item.path);
      setMobileOpen(false);
    } else {
      scrollToSection(item.label);
    }
  };

  return (
    <>
      {/* ===== GLOW BACKGROUND ===== */}
      <div className={styles.navGlowBg}></div>

      {/* ===== NAVBAR CONTAINER ===== */}
      <div className={styles.navWrapper}>
        <div className={styles.techBorder}>
          <span className={styles.cornerTech}></span>
          <span className={styles.cornerTech}></span>
          <span className={styles.cornerTech}></span>
          <span className={styles.cornerTech}></span>
        </div>

        <Toolbar className={styles.mainNav}>
          {/* Logo */}
          <motion.div whileHover={{ scale: 1.08 }} className={styles.logoContainer}>
      <Typography
        className={styles.logo}
        onClick={() => navigate("/")}
      >
        <span className={styles.logoMain}>AI-</span>
        <span className={styles.logoGlowText}>MEBOT</span>
      </Typography>
    </motion.div>

          {/* ===== DESKTOP NAV ===== */}
          {!isMobile && (
            <Box className={styles.navLinks}>
              {sections.map((item) => (
                <motion.div
                  key={item.label}
                  whileHover={{ scale: 1.1 }}
                  onMouseEnter={() => setHoveredLink(item.label)}
                  onMouseLeave={() => setHoveredLink(null)}
                  className={styles.navItemWrapper}
                >

                  <div
                    className={styles.navItemGlow}
                    data-active={hoveredLink === item.label}
                  ></div>

                  <Button
                    disableRipple
                    className={`${format.navLink} ${styles.techNavLink}`}
                    onClick={() => handleNavClick(item)}
                  >
                    {item.label.charAt(0).toUpperCase() + item.label.slice(1)}
                    <span className={styles.linkUnderline}></span>
                  </Button>
                </motion.div>
              ))}
            </Box>
          )}

          {/* ===== DESKTOP ACTIONS ===== */}
          {!isMobile && (
            <Box className={styles.actionBox}>
              <motion.div whileHover={{ scale: 1.05 }}>
                <Button
                  className={`${styles.actionBtn} ${styles.exploreBtn}`}
                  onClick={() => scrollToSection("contextexception")}
                >
                   Explore
                </Button>
              </motion.div>

              <motion.div whileHover={{ scale: 1.05 }}>
                <Button
                  className={`${styles.actionBtn} ${styles.signInBtn}`}
                  onClick={() => navigate("/login")}
                >
                   Sign In
                </Button>
              </motion.div>
            </Box>
          )}

          {/* ===== MOBILE MENU ICON ===== */}
          {isMobile && (
            <IconButton onClick={handleDrawerToggle} className={styles.menuBtn}>
              {mobileOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          )}
        </Toolbar>
      </div>

      {/* ===== MOBILE DRAWER ===== */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        classes={{ paper: styles.drawerPaper }}
      >
        <Box className={styles.drawerContainer}>
          <div className={styles.drawerHeader}>
            <Typography className={styles.drawerLogo}>
              AI-<span className={styles.drawerLogoGlow}>MEBOT</span>
            </Typography>
            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          </div>

          {/* Drawer Links */}
          <div className={styles.drawerLinks}>
            {sections.map((item) => (
              <motion.div key={item.label} whileHover={{ x: 10 }}>
                <Button
                  className={styles.drawerLink}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </Button>
              </motion.div>
            ))}
          </div>

          {/* Drawer Actions */}
          <div className={styles.drawerActions}>
            <Button
              className={styles.drawerLoginBtn}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>

            <Button className={styles.drawerSignUpBtn}>
              Sign Up
            </Button>
          </div>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;